import React from "react";
var __jsx = React.createElement;
import useToggleBlockToolbar from '../../hooks/useToggleBlockToolbar';
import { BlockToolbar } from '../BlockToolbar';
import { Container, OpenButton } from './ToggleBlockToolbar.style';

var ToggleBlockToolbar = function ToggleBlockToolbar(_ref) {
  var editorState = _ref.editorState,
      setEditorState = _ref.setEditorState,
      enabledBlocks = _ref.enabledBlocks,
      insertTable = _ref.insertTable;

  var _useToggleBlockToolba = useToggleBlockToolbar(editorState),
      isOpen = _useToggleBlockToolba.isOpen,
      isVisible = _useToggleBlockToolba.isVisible,
      buttonPosition = _useToggleBlockToolba.buttonPosition,
      toggleToolbar = _useToggleBlockToolba.toggleToolbar;

  if (!isVisible) {
    return null;
  }

  return __jsx(Container, {
    style: buttonPosition,
    onClick: toggleToolbar,
    "data-testid": "toggle-block-toolbar"
  }, __jsx(OpenButton, null), isOpen && __jsx(BlockToolbar, {
    setEditorState: setEditorState,
    enabledBlocks: enabledBlocks,
    insertTable: insertTable
  }));
};

export default ToggleBlockToolbar;